import CustomizableScan from "./CustomizableScan";

export default CustomizableScan;
